// Sepet çekmecesindeki "+ Ekle" önerileri: ürünü sepete ekleyip çekmeceyi yeniler.
document.addEventListener('click', async (event) => {
  const button = event.target.closest('.gm-upsell__add');
  if (!button) return;

  event.preventDefault();
  const drawer = document.querySelector('cart-drawer');
  button.disabled = true;

  try {
    const response = await fetch(`${routes.cart_add_url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
        sections: drawer.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
      }),
    });
    const state = await response.json();

    if (!response.ok) {
      button.textContent = 'Stokta yok';
      return;
    }

    drawer.renderContents(state);
  } catch (error) {
    console.error(error);
    button.disabled = false;
  }
});
